import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import useMeasure from '@/hooks/useMeasure/useMeasure';
import { useEffect, useRef } from 'react';
import Layout from '../Layout/Layout';
import { LayoutVariant } from '../Layout/interfaces';
import { createImageURL } from '../LegacyPicture/image-transformer/helpers';
import type { HeatPumpLayoutProps } from './types';

const HeatPumpLayout = ({
  background = 'gradient',
  backgroundImage,
  children,
}: HeatPumpLayoutProps) => {
  const layoutRef = useRef<HTMLDivElement>(null);
  const { width } = useMeasure(layoutRef);

  const getBreakpointForWidth = (width: number) => {
    if (width <= BreakPoint.XS) {
      return BreakPoint.XS;
    }

    if (width <= BreakPoint.MD) {
      return BreakPoint.MD;
    }

    return BreakPoint.XL;
  };

  const backgroundWidth = getBreakpointForWidth(width);

  useEffect(() => {
    if (layoutRef.current && backgroundImage) {
      layoutRef.current.style.backgroundImage = `url(${createImageURL(
        backgroundImage.path,
        {
          w: backgroundWidth,
          q: 75,
          dpr: 1,
        }
      )}), linear-gradient(
        90deg,
        #990099 0%,
        #ff0000 100%
      )`;
      layoutRef.current.style.backgroundRepeat = 'repeat-y';
      layoutRef.current.style.backgroundSize = '100% auto';
    }
  }, [backgroundImage, backgroundWidth]);

  return (
    <Layout
      variant={LayoutVariant.Default}
      background={background}
      ref={layoutRef}
    >
      {children}
    </Layout>
  );
};

export default HeatPumpLayout;
